const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#e98800',
                hover: '#d47400'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
